import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import cx from "classnames";
import "./ExpandPanel.less";

@observer
class ExpandPanel extends Component {
  render() {
    const { label, openLabel, open, className, children, onClick } = this.props;

    const closedLabel = label;
    const actualOpenLabel = openLabel || label;

    return (
      <div className={cx("expand-panel", className, { open })}>
        <div className="header">
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              onClick();
            }}
            className="expand-button"
          >
            {open ? `▼ ${actualOpenLabel}` : `► ${closedLabel}`}
          </a>
        </div>
        <div className="panel">{children}</div>
      </div>
    );
  }
}

ExpandPanel.propTypes = {
  // contracted label (default)
  label: PropTypes.string.isRequired,
  openLabel: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ExpandPanel;
